import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MapsSearchOptions } from '../maps-search-options.interface';
import { MapsSearchService } from '../maps-search.service';

@Component({
  selector: 'app-maps-search',
  templateUrl: './maps-search.component.html',
  styleUrls: ['./maps-search.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MapsSearchComponent implements OnInit {

  constructor(public mapsSearchService: MapsSearchService) { }

  @Input() set options(opt: MapsSearchOptions) {
    this.attachChanges(opt)
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.mapsSearchService.addCustomSearchListeners();
  }

  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
      if (this.mapsSearchService.hasOwnProperty(a)) this.mapsSearchService[a] = options[a]
    });
  }

  clearSearch() {
    var isEmpty = (<HTMLInputElement>document.getElementById('pac-input')).value;
    if(isEmpty != '') {
      (<HTMLInputElement>document.getElementById('pac-input')).value = '';
      (<HTMLInputElement>document.getElementById('pac-container')).innerHTML = '';
      this.clearGenericMarker();
    }
  };

  clearGenericMarker() {
    let w = (<any>window),
    pacInput = (<HTMLInputElement>document.getElementById('pac-input')),
    pacInputIcon = document.getElementById('pac-input-icon'),
    clearIcon = document.getElementById('clear-icon');
    pacInput.value === '' && w.autoComplete.marker && w.autoComplete.marker.setMap(null);
    if (pacInput.value.length < 1) { 
      pacInputIcon.classList.remove('hidden');
      clearIcon.classList.add('hidden');
    } else {
      clearIcon.classList.remove('hidden');
      pacInputIcon.classList.add('hidden');
     }
  };

  addFocusClass() {
    document.getElementById('search-wrapper').className = 'search-input-wrapper';
    if((<HTMLInputElement>document.getElementById('pac-input')).value.length > 0) {
      document.getElementById('clear-icon').classList.remove('hidden');
      document.getElementById('pac-input-icon').classList.add('hidden');
    }
  };

  removeFocusClass() {
    document.getElementById('clear-icon').classList.add('hidden');
    document.getElementById('pac-input-icon').classList.remove('hidden');
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/maps-search/maps-search/maps-search.component.ts